import VoucherLoginFields from './loginMethods/VoucherLoginFields';
import PMSLoginFields from './loginMethods/PMSLoginFields';
import OTPLoginFields from './loginMethods/OTPLoginFields';
import ResidentLoginFields from './loginMethods/ResidentLoginFields';
import StaffLoginFields from './loginMethods/StaffLoginFields';

// Single source of truth for which auth methods the guest portal can render.
// Both the tab list AND the render lookup in Landing.jsx read from this same
// object, so a method can never appear as a tab without also being
// renderable (or vice versa) — drift between the two is structurally
// impossible by construction.
//
// Keep this list in sync with SUPPORTED_LOGIN_METHODS in
// backend/controllers/portal.controller.js — that's the backend-side
// allowlist that decides which methods ever reach the frontend at all, so
// they need to agree on what "supported" means.
//
// icon/label may be plain strings or functions of `portalData` (used by
// `pms`, whose icon/label vary by organizationType — hotel/campus/mall/etc).
export const AUTH_METHOD_REGISTRY = {
    voucher: {
        userType: 'visitor',
        component: VoucherLoginFields,
        icon: 'fa-ticket-alt',
        label: 'Voucher',
    },
    pms: {
        userType: 'guest',
        component: PMSLoginFields,
        icon: (portalData) => (
            portalData.organizationType === 'hotel' ? 'fa-hotel' :
            portalData.organizationType === 'campus' ? 'fa-graduation-cap' :
            portalData.organizationType === 'mall' ? 'fa-store' : 'fa-id-card'
        ),
        label: (portalData) => (
            portalData.organizationType === 'hotel' ? 'Guest' :
            portalData.organizationType === 'campus' ? 'Student' :
            portalData.organizationType === 'mall' ? 'Shopper' : 'Member'
        ),
    },
    otp: {
        userType: 'otp',
        component: OTPLoginFields,
        icon: 'fa-mobile-alt',
        label: 'OTP Login',
    },
    resident: {
        userType: 'resident',
        component: ResidentLoginFields,
        icon: 'fa-key',
        label: 'Resident',
    },
    staff: {
        userType: 'staff',
        component: StaffLoginFields,
        icon: 'fa-id-badge',
        label: 'Staff',
    },
};
